
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class DesignBOMSelectGrid extends Serenity.EntityGrid<DesignBOMRow, any> {
        protected getColumnsKey() { return 'OMS.DesignBOM'; }
        protected getDialogType() { return <any>DesignBOMDialog; }
        protected getIdProperty() { return DesignBOMRow.idProperty; }
        protected getLocalTextPrefix() { return DesignBOMRow.localTextPrefix; }
        protected getService() { return DesignBOMService.baseUrl; }
        //protected getInsertPermission() { return DesignBOMRow.insertPermission; }
        //protected getUpdatePermission() { return DesignBOMRow.updatePermission; }
        //protected getDeletePermission() { return DesignBOMRow.deletePermission; }
        //protected useViewMode() { return true; }
        private rowSelection: Serenity.GridRowSelectionMixin;
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery) {
            super(container);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            return this;
        }

        get selectedItems(): DesignBOMRow[] {
                var _this = this;
                return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideDesignBOMs && this.options.hideDesignBOMs.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["BOMDesignId" /* BOMDesignId */], 'not in', [this.options.hideDesignBOMs]]);
            return true;
           
        }
        
    }

    export interface DesignBOMSelectOptions {
        ParentKey?: string;
        Key?: string;
        Title?: string;
        IsGroup?: boolean;
        GrantRevoke?: boolean;
    }
}